import { render } from "./OptionsTagsExclude.vue?vue&type=template&id=b457909e"
import script from "./OptionsTagsExclude.vue?vue&type=script&lang=js"
export * from "./OptionsTagsExclude.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__